<article
  class="sm-item-list-item"
  [class.sm-item-list-item--surface-action]="!interactive && surfaceActionLabel"
  [class.sm-item-list-item--disabled]="isDisabled"
  [class.sm-item-list-item--empty]="item.quantity === 0">
  @if (!interactive && surfaceActionLabel) {
    <button type="button" class="sm-item-list-item__surface-action" [attr.aria-label]="surfaceActionLabel" (click)="handleOpen()"></button>
  }
  <div class="sm-item-list-item__metadata"><ng-content select="[inventoryMetadata]"></ng-content></div>
  @if (interactive) {
    <button
      class="sm-item-list-item__main"
      [class.sm-item-list-item__main--drag-source]="dragEnabled"
      type="button"
      (click)="handleMainClick($event)"
      (contextmenu)="handleContextMenu($event)"
      (dragstart)="preventNativeDrag($event)"
      (pointerdown)="handleDragPointerDown($event)"
      (pointermove)="handleDragPointerMove($event)"
      (pointerup)="handleDragPointerEnd($event)"
      (pointercancel)="handleDragPointerCancel($event)">
      <ng-container [ngTemplateOutlet]="itemMainContent"></ng-container>
    </button>
  } @else {
    <div class="sm-item-list-item__main sm-item-list-item__main--static">
      <ng-container [ngTemplateOutlet]="itemMainContent"></ng-container>
    </div>
  }

  <ng-template #itemMainContent>
    <span
      class="sm-item-list-item__media"
      [class.sm-item-list-item__media--touch-drag-source]="dragEnabled"
      [attr.aria-hidden]="imageActionLabel ? null : 'true'">
      @if (imageActionLabel) {
        <button type="button" class="sm-item-list-item__media-action" [attr.aria-label]="imageActionLabel"
          (click)="imageAction.emit()">
          <ng-container [ngTemplateOutlet]="mediaContent"></ng-container>
          @if (imageBadgeText) { <span class="sm-item-list-item__media-badge" aria-hidden="true">{{ imageBadgeText }}</span> }
        </button>
      } @else {
        <ng-container [ngTemplateOutlet]="mediaContent"></ng-container>
      }
    </span>
    <ng-template #mediaContent>
      @if (hasImage) {
        @if (imageActionLabel) {
          <img class="sm-item-list-item__image" [src]="item.imageUrl || ''" alt="" (error)="handleImageError()">
        } @else {
          <sm-image-preview [galleryImages]="galleryImages" [loadGalleryImages]="loadGalleryImages"
            [sourceKind]="loadGalleryImages || galleryImages !== null ? null : photoSourceKind" [sourceId]="photoSourceId ?? item.id"
            [src]="item.imageUrl || ''" [alt]="item.name" [longPressEnabled]="imageLongPressEnabled"
            (imageError)="handleImageError()"></sm-image-preview>
        }
      } @else {
        <ion-icon class="sm-item-list-item__icon" [name]="fallbackIconName"></ion-icon>
      }
    </ng-template>

    <span class="sm-item-list-item__copy">
      <span class="sm-item-list-item__badges"><ng-content select="[itemBadges]"></ng-content></span>
      <span class="sm-item-list-item__title-row">
        @if (!interactive && titleRoute) {
          <a class="sm-item-list-item__name sm-item-list-item__name--link" [routerLink]="titleRoute"><sm-search-highlight [text]="item.name" [query]="searchQuery"></sm-search-highlight></a>
        } @else {
          <span class="sm-item-list-item__name"><sm-search-highlight [text]="item.name" [query]="searchQuery"></sm-search-highlight></span>
        }
      @if (item.isFavorite) { <ion-icon class="favorite-star" name="star" role="img" [attr.aria-label]="'favorites.selected' | translate"></ion-icon> }
        @if (showKindLabel) {
          <ion-icon class="sm-item-list-item__kind" [name]="fallbackIconName" role="img"
            [attr.aria-label]="'homePage.itemKindLabel' | translate"
            [attr.title]="'homePage.itemKindLabel' | translate"></ion-icon>
        }
        @if (quantityLabel && (item.packagingQuantity === null || item.packagingQuantity === undefined)) {
          <span class="sm-item-list-item__quantity">{{ quantityLabel }}</span>
        }
      </span>

      @if ((item.packagingQuantity !== null && item.packagingQuantity !== undefined)) {
        <sm-stock-summary [quantity]="item.quantity" [packagingQuantity]="item.packagingQuantity"
          [remaining]="item.remainingContent" [unitLabel]="item.packagingUnitLabel" [stockUnitLabel]="item.unitLabel" />
      }
      <sm-rich-tooltip
        class="sm-item-list-item__description"
        [previewText]="description"
        [searchQuery]="item.description ? searchQuery : ''"
        [html]="item.description"
        [emptyLabel]="emptyDescriptionLabel">
      </sm-rich-tooltip>

      @if (item.contextPathText || item.contextText) {
        <div class="sm-item-list-item__context">
          <ion-icon
            class="sm-item-list-item__context-icon"
            [name]="item.contextIconName || 'location-outline'">
          </ion-icon>
          <div class="sm-item-list-item__context-copy">
            @if (item.contextPathText) {
              <span class="sm-item-list-item__context-path" [attr.aria-label]="item.contextAriaLabel || item.contextPathText">
                {{ item.contextPathText }}
              </span>
            } @else {
              <span class="sm-item-list-item__context-text" [attr.aria-label]="item.contextAriaLabel || item.contextText">
                {{ item.contextText }}
              </span>
            }

            @if (item.contextMetaText) {
              <span class="sm-item-list-item__context-meta">{{ item.contextMetaText }}</span>
            }
          </div>
        </div>
      }
      <div class="sm-item-list-item__body"><ng-content select="[itemBody]"></ng-content></div>
    </span>
  </ng-template>

  @if (inventoryMenu) {
    <sm-item-context-menu class="sm-item-list-item__menu" [entity]="item"
      [options]="inventoryMenu" [triggerAriaLabel]="menuAriaLabel || item.name" triggerVariant="ellipsis"
      (itemSelect)="handleMenuItemSelect($event)">
      <span class="sm-item-list-item__menu-trigger">
        <ion-icon name="ellipsis-vertical"></ion-icon>
      </span>
    </sm-item-context-menu>
  } @else if (menuItems.length) {
    <sm-context-menu
      class="sm-item-list-item__menu"
      [items]="menuItems"
      [triggerAriaLabel]="menuAriaLabel || item.name"
      triggerVariant="ellipsis"
      menuWidth="content"
      (itemSelect)="handleMenuItemSelect($event)">
      <span smContextMenuTrigger class="sm-item-list-item__menu-trigger">
        <ion-icon name="ellipsis-vertical"></ion-icon>
      </span>
    </sm-context-menu>
  }
  <div class="sm-item-list-item__footer"><ng-content select="[inventoryFooter]"></ng-content></div>
</article>
